import { Priority } from '../../configuration/alert-rules/models/alert-rule';

export class Alert {
    // eslint-disable-next-line max-params
    constructor(
        readonly id: number,
        readonly name: string,
        readonly color: string,
        readonly priority: Priority,
        readonly resource: AlertResource,
        readonly description: string,
        readonly notificationChannels: NotificationChannel[],
        readonly status: AlertStatus,
        readonly date: string
    ) { }
}

export class NotificationChannel {
    constructor(
        readonly via: AlertVia,
        readonly value: string
    ) { }
}

export enum AlertVia {
    Email = 'mail',
    Sms = 'sms'
}

export enum AlertStatus {

    Fulfilled = 'fulfilled',
    NotFulfilled = 'not-fulfilled'
}

export enum AlertResource {
    Cpu = 'cpu',
    Ram = 'ram',
    Disk = 'disk',
    Java = 'java'
}
